import React, {useEffect, useState} from "react";
import {Button} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {Link} from "react-router-dom";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {AdminCrudList} from "Views/Shared/Crud/AdminCrudList";
import {getBankSwiftCodes} from "Api/Query/BankSwiftCodeQuery";
import {deleteBankSwiftCodes} from "Api/Mutation/BankSwiftCodeMutation";
import {useMutation} from "react-query";
import {Notificator} from "Services/Notificator/Notificator";
import {appLoading} from "Store/loadingSlice";
import {useAppDispatch} from "hooks";

export const AdminBankSwiftCodeList: React.FC = () => {

    const dispatch = useAppDispatch();
    const [refresh, setRefresh] = useState<boolean>(false);

    const headers: string[] = ['CÓDIGO BANCO', 'BIC', 'BANCO'];

    const deleteMutation = useMutation({
        mutationKey: ['deleteBankSwiftCode'],
        mutationFn: (id: string) => deleteBankSwiftCodes([id]),
        onSuccess: () => {
            Notificator.success('El código SWIFT se ha eliminado correctamente.');
            setRefresh(!refresh);
        },
        onError: () => {
            Notificator.error('Se ha producido un error al eliminar el código SWIFT.');
        }
    });

    const remove = (id: string) => {
        if (!window.confirm('¿Deseas eliminar este código SWIFT?')) return;
        deleteMutation.mutate(id);
    };

    useEffect(() => {
        dispatch(appLoading({value: deleteMutation.isLoading, text: 'Eliminando'}));
    }, [deleteMutation.isLoading]);

    return (
        <RequireAuth>
            <AdminCrudList
                id={"bank-swift-codes"}
                title={"Códigos SWIFT bancarios"}
                headers={headers}
                queryMethod={getBankSwiftCodes}
                queryName={"adminListBankSwiftCodes"}
                deleteMethod={deleteBankSwiftCodes}
                refreshSwitch={refresh}
                tableRow={(item: any, key: number) =>
                    <>
                        <td>
                            <Link to={ROUTE_PATHS.ADMIN_BANK_SWIFT_CODES_EDIT.replace(":id", item.id)}>
                                {item.id}
                            </Link>
                        </td>
                        <td>{item.bic}</td>
                        <td>{item.bank}</td>
                        <td className={"text-center align-middle"}>
                            <Button
                                className={"purple-btn btn-sm"}
                                href={ROUTE_PATHS.ADMIN_BANK_SWIFT_CODES_EDIT.replace(":id", item.id)}
                            >
                                Modificar
                            </Button>
                            &nbsp;
                            <Button
                                className={"btn-dark btn-sm"}
                                onClick={() => remove(item.id)}
                            >
                                Eliminar
                            </Button>
                        </td>
                    </>
                }
                createButton={
                    <Button
                        className={"purple-btn"}
                        href={ROUTE_PATHS.ADMIN_BANK_SWIFT_CODES_CREATE}
                    >
                        Crear código SWIFT
                    </Button>
                }
            />
        </RequireAuth>
    );
};
